import { createSlice } from '@reduxjs/toolkit';

export const restrictionsSlice = createSlice({
    name: 'restrictions',
    initialState: null,
    reducers: {
        setAccessValue: (state, action) => action.payload,
    },
});

export const { setAccessValue } = restrictionsSlice.actions;

export default restrictionsSlice.reducer;
